import { Component } from '@angular/core';
import {HeroMoviLinkComponent} from "../../../app-persona/movi-link/hero-pages/hero-movi-link.component";

@Component({
  selector: 'app-hero-enterprise',
  standalone: true,
  imports: [],
  templateUrl: 'hero-enterprise.component.html',
  styleUrl: './hero-enterprise.component.css'
})
export class HeroEnterpriseComponent {
  title = 'Servicios Empresariales';
  subtitle1 = 'Colaboradores sanos';
  subtitle2 = 'empresa más productiva';
  callToAction = 'Contáctanos';
  routeImageMain = 'assets/img/enterprise/bannerEmpresarial.svg';


}
